var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"photoList list10senNew_01"},[_c('div',{staticClass:"inner2"},[_c('div',{staticClass:"stage",staticStyle:{"height":"800px"}},[_vm._v("   ")])])])])
}]

export { render, staticRenderFns }